import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { SEND_CALLBACKS } from "./actionTypes";
import { sendCallbacksSuccess, sendCallbacksError } from "./actions";

// Include call API
import { getTasksAPI } from "../../../api/tasks";

const tasksAPI = getTasksAPI();

function* sendCallbacks({ payload: { user } }) {
  try {
    const response = yield call(
      tasksAPI.sendCallbacksPending,
      user.name,
      user.token
    );
    yield put(sendCallbacksSuccess(response.status, response.message));
  } catch (error) {
    yield put(sendCallbacksError(error));
  }
}

export function* watchSendCallbacks() {
  yield takeEvery(SEND_CALLBACKS, sendCallbacks);
}

function* sendCallbacksSaga() {
  yield all([fork(watchSendCallbacks)]);
}

export default sendCallbacksSaga;
